import { Injectable } from '@angular/core';
import StreamingAvatar from '@heygen/streaming-avatar';
import { BotCardType, DialogMessage, HistoryItemResponse } from '@shared/index';
import confetti from 'canvas-confetti';
import chance from 'chance';
// eslint-disable-next-line no-restricted-imports
import { ChartService } from '@shared-angular/services/chart.service';
import { ToastrService } from 'ngx-toastr';
import qs from "qs";
import { BUTTONCARDBUTTON } from '../../components/ai-bot/utils/bot-chat-dialog/message-card/button-card/button-card.component';
import { FalaiImageService } from '../ai/image/falaiImage.service';
import { OpenaiImageService } from '../ai/image/openaiImage.service';
import { StableDiffusionImageService } from '../ai/image/stablediffusionImage.service';
import { OpenaiAdminService } from '../ai/text/openai-admin.service';
import { VllmAdminService } from '../ai/text/vllm-admin.service';
import { AudioManagerService } from '../audio-manager.service';
import { AudioToTextService } from '../audio-to-text/audio-to-text.service';
import { BotService } from '../bot.service';
import { CardsManagerService } from '../cards-manager.service';
import { DialogStoreManagerService } from '../dialog-store-manager.service';
import { DocSearchManagerService } from '../doc-search-manager.service';
import { DOMManagerService } from '../dommanager.service';
import { AdobeconnectManagerService } from './../../../adobeconnect-manager.service';

import { GammaService } from '@shared-angular/services/ai/gamma/gamma.service';
import { EndBotOptions, EndbotService } from '@shared-angular/services/endbot.service';
import { InactiveBotServiceService } from '@shared-angular/services/inactive-bot-service.service';
import { LoginService } from '@shared-angular/services/login.service';
import { MsgProcessingService } from '@shared-angular/services/msg-processing.service';
import { PromptbarManagerService } from '@shared-angular/services/promptbar-manager.service';
import { RagLoggerService } from '@shared-angular/services/rag-logger/rag-logger.service';
import { DialogRecorderService } from 'src/app/dialog-recorder.service';
import { ParentManagerService } from 'src/app/parent-manager.service';
import { QuizManagerService } from 'src/app/quiz-manager.service';
import { BotGroupchatService } from '../bot-groupchat.service';
import { DownloadManagerService } from '../download-manager.service';
import { EventManagerAdminService } from '../event-manager/event-manager-admin.service';
import { FusionviewManagerService } from '../fusionview-manager/fusionview-manager.service';
import { HelperManagerAdminService } from '../helper-manager-admin.service';
import { InfoManagerService } from '../info-manager.service';
import { KeyValAdminService } from '../key-val-admin.service';
import { MessageManagerAdminService } from '../message-manager-admin.service';
import { MiroService } from '../miro.service';
import { OverlayManagerService } from '../overlay-manager.service';
import { ProjectKeyValAdminService } from '../project-key-val-admin.service';
import { ChatAvatarManagerService } from '../ragai/chat-avatar-manager.service';
import { MailManagerAdminService } from '../ragai/mail-manager-admin.service';
import { VideoAvatarManagerService } from '../ragai/video-avatar-manager.service';
import { ReflactTrainService } from '../reflact-train.service';
import { ScoreService } from '../score/score.service';
import { ScormManagerService } from '../scorm-manager.service';
import { SkillService } from '../skill.service';
import { StageManagerService } from '../stage-manager.service';
import { SupervisorManagerService } from '../supervisor-manager.service';
import { VimeoManagerService } from '../vimeo-manager.service';
import { WaitForManagerService } from '../wait-for-manager.service';
import { WebhookManagerService } from '../webhook-manager.service';
import { YoutubeManagerService } from '../youtube-manager.service';
import { BotapiManagerService, PostType } from './botapi-manager.service';


declare global {
  interface Window {
    RAGAI: ReturnType<IframeCommunicationService["createRagAI"]>
    avatar?: StreamingAvatar;
    audiobot_overrideText?: string;
    avatarbot_overrideText?: string;
    buttonCardClickEvent: unknown;
    openFusionView?: (fusionViewId: string) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class IframeCommunicationService {


  public botId: string = '';

  constructor(
    private AdobeconnectManager: AdobeconnectManagerService,
    private aiVllm: VllmAdminService,
    private aiOpenAi: OpenaiAdminService,
    public attService: AudioToTextService,
    private audioManager: AudioManagerService,
    private beforeSendProcessor: MsgProcessingService,
    private botApiManager: BotapiManagerService,
    private botService: BotService,

    private cardsManager: CardsManagerService,
    private charService: ChartService,
    private chatAvatarManager: ChatAvatarManagerService,
    private dialogStoreManager: DialogStoreManagerService,
    private docSearchManager: DocSearchManagerService,
    private domManager: DOMManagerService,
    public endBotService: EndbotService,
    private eventManager: EventManagerAdminService,
    private helper: HelperManagerAdminService,
    private downloadManager: DownloadManagerService,
    public inActiveService: InactiveBotServiceService,
    private infoManager: InfoManagerService,
    public keyValService: KeyValAdminService,
    public projectKeyValAdminService: ProjectKeyValAdminService,
    private logger: RagLoggerService,
    public loginService: LoginService,
    public msgManager: MessageManagerAdminService,
    private openaiImageService: OpenaiImageService,
    private overlayService: OverlayManagerService,
    private prompBar: PromptbarManagerService,
    private score: ScoreService,
    private scormManager: ScormManagerService,
    private skillService: SkillService,
    private miroService: MiroService,
    private reflactTrainService: ReflactTrainService,
    private parentService: ParentManagerService,
    private stableDiffusionImageService: StableDiffusionImageService,
    private falaiImageService: FalaiImageService,
    private stageService: StageManagerService,
    private supervisorManager: SupervisorManagerService,
    private toastr: ToastrService,
    private mailManager: MailManagerAdminService,
    private videoAvatarManager: VideoAvatarManagerService,
    private vimeoManager: VimeoManagerService,
    private waitForManager: WaitForManagerService,
    private webhookManager: WebhookManagerService,
    private youtubeManager: YoutubeManagerService,
    private fusionViewManager: FusionviewManagerService,
    private quizManager: QuizManagerService,
    private gammaService: GammaService,
    private dialogRecorder: DialogRecorderService,
    private botGroupchatService: BotGroupchatService
  ) {
    void this.RAGAI;

    /* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call */
    window.addEventListener("message", (event) => {
      //xxx

      if (event.data.type == 'exec-result') {
        const { requestId, value } = event.data;
        const resolve = this.parentService.pending.get(requestId);
        if (resolve) {
          resolve(value);
          this.parentService.pending.delete(requestId);
        }
      }









      if (event.data.type == "executeCode") {
        if (event.data.code.startsWith("RAGAI.")) {
          eval(event.data.code);
        }
      }
    });
    /* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-call */


  }

  public get RAGAI() {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (window.RAGAI == null) {
      window.RAGAI = this.createRagAI();

      void this.RAGAI.WAITFOR.initialIdle().then(() => {
        // INITIIERUNGEN FÜR EMBED.js RAGBOT
        window.parent.postMessage({
          type: 'chatbotReady'
        }, '*');
        /* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unnecessary-condition, @typescript-eslint/restrict-template-expressions */
        window.addEventListener('message', (event) => {
          if (!event.data) return;
          if (!event.data.variable) return;
          // Optional: Origin überprüfen!
          if (!event.data.variable.startsWith("RAGAI.")) {

          }
          if (event.data && event.data.type === 'ragbotGet' && event.data.variable.startsWith("RAGAI.")) {
            const varName = event.data.variable;
            console.log("RAGBOT VARIABLE REQUEST:", varName);
            const requestId = event.data.requestId;

            // Beispiel: Du hast ein globales object window.RAGAI mit info
            let value;
            try {
              // Passe das hier an deine interne Variable(n) an!
              value = window.RAGAI && eval(`${varName}`);
              console.log("RAGBOT VARIABLE VALUE:", value);

            } catch (_e) {
              value = undefined;
            }

            // Antwort zurück an Parent
            window.parent.postMessage(
              {
                type: 'ragbotGetResponse',
                value,      // Der Wert zu varName
                requestId  // Korreliert die Antwort mit der Anfrage!
              },
              '*'
            );
          }
        });
        /* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unnecessary-condition, @typescript-eslint/restrict-template-expressions */















      });











    }
    return window.RAGAI;
  }

  private createRagAI() {
    return {
      FUNCTIONS: {},
      VARIABLES: {},
      ADOBECONNECT: this.AdobeconnectManager,
      BOTMANAGER: this.botService,
      GROUPCHAT: this.botGroupchatService,
      DIALOGRECORDER: this.dialogRecorder,
      service: this,
      lastThreadId: "",
      EVENTS: this.eventManager,
      PROMPTBAR: this.prompBar,
      BEFORE_SEND: this.beforeSendProcessor,
      LOG: this.logger,
      loggedInUser: this.loginService.loggedInUser,
      CHARTS: this.charService,
      STAGE: this.stageService, // EVENTS DONE
      KEYVAL: this.keyValService,
      PROJECTKEYVAL: this.projectKeyValAdminService,
      OVERLAY: this.overlayService,// HAT EVENTS
      CARDS: this.cardsManager,
      SCORE: this.score,
      SKILL: this.skillService,
      DOM: this.domManager,
      FUSIONVIEW: this.fusionViewManager,
      DOCSEARCH: this.docSearchManager,
      SUPERVISOR: this.supervisorManager,
      toastr: this.toastr,
      MAIL: this.mailManager,
      HELPER: this.helper,
      DOWNLOAD: this.downloadManager,
      WAITFOR: this.waitForManager,
      WEBHOOK: this.webhookManager,
      INFO: this.infoManager,
      DIALOGSTORE: this.dialogStoreManager,
      AUDIO: this.audioManager,
      CHAT_AVATAR: this.chatAvatarManager,
      VIDEO_AVATAR: this.videoAvatarManager,
      confetti: confetti,
      QUIZ: this.quizManager,
      PARENT: this.parentService,
      chance: chance(),
      AIIMAGE_OPENAI: this.openaiImageService,
      AIIMAGE_STABLEDIFFUSION: this.stableDiffusionImageService,
      AIIMAGE_FALAI: this.falaiImageService,
      AITEXT_VLLM: this.aiVllm,
      AITEXT_OPENAI: this.aiOpenAi,
      YOUTUBE: this.youtubeManager,
      VIMEO: this.vimeoManager,
      BOTAPI: this.botApiManager,
      MSG: this.msgManager,
      DEBUG: {
        log: (title: string, reason: string = "") => {
          this.eventManager._trigger_RAGAI_EVENT("RAGAI.DEBUG.log", { title, reason });
        }
      },
      MIRO: this.miroService,
      GAMMA: this.gammaService,
      qs: qs,
      SCORM: this.scormManager,
      //Ab hier noch Bereinigung notwendig
      TRAIN: {
        registerCourse: async (courseId: string) => {
          return await this.botApiManager.postMessage(PostType.registerCourse, { courseId });
        }
      },
      cancel: async () => {
        const lastThread = this.RAGAI.lastThreadId;
        const botId = this.botId;
        if (!botId) { return; }
        if (lastThread === "") { return; }
        await this.botService.sendBotThinkingCancel(botId, lastThread);
      },

      runMessage: (text: string) => {
        // console.warn("Function 'RAGAI.runMessage' deprecated. Please use RAGAI.MSG.prompt()!");
        this.msgManager.prompt(text);
      },

      restartBot: async () => {
        this.score.reset();
        await this.botService.resetBot(this.botId);
        window.location.reload();
      },
      resetBot: async () => {
        this.score.reset();
        await this.botService.resetBot(this.botId);
      },

      initialMessages: async () => { return new Promise<DialogMessage[]>((resolve) => { resolve([]); }); },
      //Ab hier deprecated function nur noch

      getCurrentDialog: async () => {
        console.warn("Function 'RAGAI.getCurrentDialog' deprecated. Please use RAGAI.DIALOGSTORE.getCurrentDialog()!");
        return await this.dialogStoreManager.getCurrentDialog();
      },
      storeDialogToLocalStorage: async (key: string) => {
        console.warn("Function 'RAGAI.storeDialogToLocalStorage' deprecated. Please use RAGAI.DIALOGSTORE.storeDialogToLocalStorage()!");
        return await this.dialogStoreManager.storeDialogToLocalStorage(key);
      },
      restoreDialogFromLocalStorage: async (dialogId: string, removeExisting: boolean = false, ignoreExisting: boolean = true) => {
        console.warn("Function 'RAGAI.restoreDialogFromLocalStorage' deprecated. Please use RAGAI.DIALOGSTORE.restoreDialogFromLocalStorage()!");
        return await this.dialogStoreManager.restoreDialogFromLocalStorage(dialogId, removeExisting, ignoreExisting);
      },
      createDialogMessageFromHistoryItem: (item: HistoryItemResponse): DialogMessage => {
        console.warn("Function 'RAGAI.createDialogMessageFromHistoryItem' deprecated. Please use RAGAI.DIALOGSTORE.createDialogMessageFromHistoryItem()!");
        return this.dialogStoreManager.createDialogMessageFromHistoryItem(item);
      },
      addDialogMessagesFromHistoryItems: async (historyItems: HistoryItemResponse[], ignoreExisting: boolean) => {
        console.warn("Function 'RAGAI.addDialogMessagesFromHistoryItems' deprecated. Please use RAGAI.DIALOGSTORE.addDialogMessagesFromHistoryItems()!");
        return await this.dialogStoreManager.addDialogMessagesFromHistoryItems(historyItems, ignoreExisting);
      },
      overrideDialogFromLocalStorage: async (dialogId: string) => {
        console.warn("Function 'RAGAI.overrideDialogFromLocalStorage' deprecated. Please use RAGAI.DIALOGSTORE.overrideDialogFromLocalStorage()!");
        return await this.dialogStoreManager.restoreDialogFromLocalStorage(dialogId, true, false);
      },
      appendDialogFromLocalStorage: async (dialogId: string) => {
        console.warn("Function 'RAGAI.appendDialogFromLocalStorage' deprecated. Please use RAGAI.DIALOGSTORE.appendDialogFromLocalStorage()!");
        return await this.dialogStoreManager.appendDialogFromLocalStorage(dialogId);
      },
      appendDialogFromLocalStorageIgnoreExisting: async (dialogId: string) => {
        console.warn("Function 'RAGAI.appendDialogFromLocalStorageIgnoreExisting' deprecated. Please use RAGAI.DIALOGSTORE.appendDialogFromLocalStorageIgnoreExisting()!");
        return await this.dialogStoreManager.appendDialogFromLocalStorageIgnoreExisting(dialogId);
      },
      addMessage: async (payload: string) => {
        console.warn("Function 'RAGAI.addMessage' deprecated. Please use RAGAI.MSG.userBypass()!");
        return await this.msgManager.userBypass(payload);
      },
      botMessage: async (text: string) => {
        console.warn("Function 'RAGAI.botMessage' deprecated. Please use RAGAI.MSG.botMessage()!");
        return await this.msgManager.botMessage(text);
      },
      botSay: async (text: string, voice: string | undefined) => {
        console.warn("Function 'RAGAI.botSay' deprecated. Please use RAGAI.AUDIO.botSay()!");
        return this.audioManager.botSay(text, voice);
      },
      addMessagesToThread: async (messages: DialogMessage[]) => {
        console.warn("Function 'RAGAI.addMessagesToThread' deprecated.");
        return this.msgManager._addMessagesToThread(messages);
      },
      addDialogMessages: async (messages: DialogMessage[]) => {
        console.warn("Function 'RAGAI.addDialogMessages' deprecated.");
        return await this.RAGAI.addMessagesToThread(messages);
      },
      callExternalFunction: async (name: string, ...args: unknown[]) => {
        console.warn("Function 'RAGAI.callExternalFunction' deprecated. Please use RAGAI.botApiManager.callExternalFunction()!");
        return await this.botApiManager.callExternalFunction(name, args);
      },
      getRegisteredFunctionNames: async () => {
        console.warn("Function 'RAGAI.getRegisteredFunctionNames' deprecated. Please use RAGAI.botApiManager.getRegisteredFunctionNames()!");
        return await this.botApiManager.getRegisteredFunctionNames();
      },
      addBotCard: async (payload: { type: string, data: unknown }) => {
        console.warn("Function 'RAGAI.addBotCard' deprecated. Please use RAGAI.CARDS.addBotCard()!");
        return await this.cardsManager.addBotCard(payload);
      },
      userMessage: (text: string) => {
        console.warn("Function 'RAGAI.userMessage' deprecated. Please use RAGAI.MSG.userMessage()!");
        this.msgManager.userMessage(text);
      },

      userBypass: async (text: string) => {
        console.warn("Function 'RAGAI.userBypass' deprecated. Please use RAGAI.MSG.userBypass()!");
        await this.msgManager.userBypass(text);
      },

      addMessageBot: async (payload: string) => {
        console.warn("Function 'RAGAI.addMessageBot' deprecated. Please use RAGAI.MSG.botBypass()!");
        const res = await this.msgManager.botBypass(payload);
        if (res[0] != null) {
          return res[0];
        }
        throw new Error("Failed to addMessageBot");
      },
      botBypass: async (text: string) => {
        console.warn("Function 'RAGAI.botBypass' deprecated. Please use RAGAI.MSG.botBypass()!");
        return await this.msgManager.botBypass(text);
      },

      buttonsCard: async (buttons: BUTTONCARDBUTTON[], cssClass: string = '') => {
        console.warn("Function 'RAGAI.buttonsCard' deprecated. Please use RAGAI.CARDS.buttons()!");
        await this.cardsManager.buttons(buttons, cssClass);
      },
      youtubeCard: async (id: string, cssClass: string = '') => {
        console.warn("Function 'RAGAI.youtubeCard' deprecated. Please use RAGAI.CARDS.youtube()!");
        await this.cardsManager.addBotCard({ type: BotCardType.youtubeCard, data: { id, cssClass } });
      },
      vimeoCard: async (id: string, hash: string, cssClass: string = '') => {
        console.warn("Function 'RAGAI.vimeoCard' deprecated. Please use RAGAI.CARDS.vimeo()!");
        await this.cardsManager.addBotCard({ type: BotCardType.vimeoCard, data: { id, hash, cssClass } });
      },
      imageCard: async (src: string, altText: string = '', cssClass: string = '') => {
        console.warn("Function 'RAGAI.imageCard' deprecated. Please use RAGAI.CARDS.image()!");
        await this.cardsManager.addBotCard({ type: BotCardType.imageCard, data: { src, altText, cssClass } });
      },
      iframeCard: async (url: string, cssClass: string = '') => {
        console.warn("Function 'RAGAI.iframeCard' deprecated. Please use RAGAI.CARDS.iframe()!");
        await this.cardsManager.addBotCard({ type: BotCardType.iframeCard, data: { url, cssClass } });
      },
      htmlCard: async (html: string, cssClass: string = '') => {
        console.warn("Function 'RAGAI.htmlCard' deprecated. Please use RAGAI.CARDS.html()!");
        await this.cardsManager.addBotCard({ type: BotCardType.htmlCard, data: { html, cssClass } });
      },
      showOverlay: (text: string, onClose?: () => void) => {
        console.warn("Function 'RAGAI.showOverlay' deprecated. Please use RAGAI.OVERLAY.text()!");
        this.overlayService.text(text, onClose);
      },
      closeOverlay: () => {
        console.warn("Function 'RAGAI.closeOverlay' deprecated. Please use RAGAI.OVERLAY.close()!");
        this.overlayService.close();
      },
      showOverlayWithButtons: (buttons: { text: string; onClick: () => void; className?: string; }[], onClose?: () => void) => {
        console.warn("Function 'RAGAI.showOverlayWithButtons' deprecated. Please use RAGAI.OVERLAY.button()!");
        this.overlayService.button(buttons, onClose);
      },
      showOverlayWithTextAndButtons: (text: string, buttons: { text: string; onClick: () => void; className?: string; }[], onClose?: () => void) => {
        console.warn("Function 'RAGAI.showOverlayWithTextAndButtons' deprecated. Please use RAGAI.OVERLAY.textAndButton()!");
        this.overlayService.textAndButton(text, buttons, onClose);
      },
      showOverlayWithHTML: (htmlContent: string, onClose?: () => void) => {
        console.warn("Function 'RAGAI.showOverlayWithHTML' deprecated. Please use RAGAI.OVERLAY.html()!");
        this.overlayService.html(htmlContent, onClose);
      },
      downloadTextAsFile: (text: string, filename: string) => {
        console.warn("Function 'RAGAI.downloadTextAsFile' deprecated. Please use RAGAI.DOWNLOAD.textAsFile()!");
        this.downloadManager.textAsFile(text, filename);

      },
      copyToClipboard: (text: string) => {
        console.warn("Function 'RAGAI.copyToClipboard' deprecated. Please use RAGAI.DOWNLOAD.copyToClipboard()!");
        this.helper.copyToClipboard(text);
      },
      closeWindow: () => {
        console.warn("Function 'RAGAI.closeWindow' deprecated. Please use RAGAI.HELPER.closeWindow()!");
        this.helper.closeWindow();
      },
      endBot: (opts: Partial<EndBotOptions> = {}) => {
        console.warn("Function 'RAGAI.endBot' deprecated. Please use RAGAI.HELPER.endBot()!");
        opts.autoRedirectSeconds ??= -1;
        opts.message ??= "Bot wurde beendet";
        opts.title ??= "Bot beendet";
        this.endBotService.endBot(this.botId, opts as EndBotOptions);
      },
      addStat: async (stat: string) => {
        console.warn("Function 'RAGAI.addStat' deprecated. Please use RAGAI.HELPER.addStat()!");
        return await this.botService.addStat(this.botId, stat);
      },
      downloadMaterial: async (skillId: string) => {
        console.warn("Function 'RAGAI.downloadMaterial' deprecated. Please use RAGAI.HELPER.downloadMaterial()!");
        const docInfo = await this.botService.getFileInformation(this.botId, skillId);
        const docContent = await this.botService.getDownloadableMaterial(this.botId, docInfo.id);
        const blob = new Blob([docContent], { type: docInfo.type });
        const fileURL = URL.createObjectURL(blob);
        const element = document.createElement('a');
        element.setAttribute('href', fileURL);
        element.setAttribute('download', docInfo.name);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        URL.revokeObjectURL(fileURL);
      },
      score: this.score,
      enableSkills: async (skillIds: string[]) => {
        console.warn("Function 'RAGAI.enableSkills' deprecated. Please use RAGAI.SKILL.enableSkills()!");
        return await this.skillService.enableSkills(skillIds);
      },
      disableSkills: async (skillIds: string[]) => {
        console.warn("Function 'RAGAI.disableSkills' deprecated. Please use RAGAI.SKILL.disableSkills()!");
        return await this.skillService.disableSkills(skillIds);
      },
      enableSkillAndChildren: async (skillId: string, depth: number = Number.MAX_SAFE_INTEGER) => {
        console.warn("Function 'RAGAI.enableSkillAndChildren' deprecated. Please use RAGAI.SKILL.enableSkillAndChildren()!");
        return await this.skillService.enableSkillAndChildren(skillId, depth);
      },
      disableSkillAndChildren: async (skillId: string, depth: number = Number.MAX_SAFE_INTEGER) => {
        console.warn("Function 'RAGAI.disableSkillAndChildren' deprecated. Please use RAGAI.SKILL.disableSkillAndChildren()!");
        return await this.skillService.disableSkillAndChildren(skillId, depth);
      },
      skillsForNextRun: async (skillIds: string[]) => {
        console.warn("Function 'RAGAI.skillsForNextRun' deprecated. Please use RAGAI.SKILL.skillsForNextRun()!");
        return await this.skillService.skillsForNextRun(skillIds);
      },
      unforceAllSkills: async () => {
        console.warn("Function 'RAGAI.unforceAllSkills' deprecated. Please use RAGAI.SKILL.unforceAllSkills()!");
        return await this.skillService.unforceAllSkills();
      },
      getSkills: async () => {
        console.warn("Function 'RAGAI.getSkills' deprecated. Please use RAGAI.SKILL.getSkills()!");
        return await this.skillService.getSkills();
      }
    };
  }


  public runComplete(payload: HistoryItemResponse) {
    this.eventManager.triggerEventHook("runComplete", payload.content);
    this.eventManager.triggerEventHook("RAGAI.MSG.runComplete", payload);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const msg = payload.content.at(0)!;
    if (payload.role == "assistant" && msg.type === "text") {
      this.msgManager.onBotToUser.emit(msg.text);
    };
    //? skip event if it's not from parent (skip if the frame is it's own parent)
    if (window.parent == window) return;
    void this.botApiManager.postMessage(PostType.runComplete, payload.content);
  }
}
